import { fallbackRestUrl } from './path';

function isAppHomePath(path: string): boolean {
  const base = path.split('#')[0].split('?')[0];
  return base === '/app/home';
}

function hasHandoffQuery(path: string): boolean {
  const q = path.split('?')[1]?.split('#')[0];
  if (!q) return false;
  return new URLSearchParams(q).has('handoff');
}

function appendQueryParam(path: string, key: string, value: string): string {
  const [beforeHash, ...hashParts] = path.split('#');
  const hash = hashParts.length ? hashParts.join('#') : undefined;
  const sep = beforeHash.includes('?') ? '&' : '?';
  const next = `${beforeHash}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  return hash !== undefined ? `${next}#${hash}` : next;
}

async function fetchHandoffValue(token?: string): Promise<string | null> {
  if (!token) return null;
  try {
    const apiUrl = process.env.REST_URL || fallbackRestUrl;
    const response = await fetch(`${apiUrl}/auth/handoff-token-request`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    const value = data?.result?.handoff_token;
    return typeof value === 'string' && value.length > 0 ? value : null;
  } catch {
    return null;
  }
}

/** Use when redirecting to home after a successful login / register / magic link. */
export async function pathWithPostLoginHandoff(
  redirectTo: string | null | undefined,
  token?: string
): Promise<string> {
  const target = redirectTo ?? '/app/home';
  if (!isAppHomePath(target)) return target;
  if (hasHandoffQuery(target)) return target;
  const handoffValue = await fetchHandoffValue(token);
  if (!handoffValue) return target;
  return appendQueryParam(target, 'handoff', handoffValue);
}
